/**
 * useDeleteCommunityImage Hook
 * Mutation hook for deleting community images
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { deleteCommunityImage } from "../services/community.service"

interface DeleteCommunityImageVariables {
  communityId: string
  uploadId: string
}

export function useDeleteCommunityImage() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ communityId, uploadId }: DeleteCommunityImageVariables) =>
      deleteCommunityImage(communityId, uploadId),

    onSuccess: () => {
      // Invalidate community images query to refetch
      queryClient.invalidateQueries({
        queryKey: ["community"],
      })
      toast.success("Image deleted successfully")
    },

    onError: () => {
      toast.error("Failed to delete image")
    },
  })
}
